// YouTube share links come in three shapes (watch?v=, youtu.be/, /embed/) —
// the player and the thumbnails all live under the same 11-char video id.
const YOUTUBE_VIDEO_ID_PATTERN = /(?:youtu\.be\/|[?&]v=|\/embed\/)([\w-]{11})/;

export const getYouTubeVideoId = (youtubeUrl: string): string => {
  const videoId = YOUTUBE_VIDEO_ID_PATTERN.exec(youtubeUrl)?.[1];
  if (!videoId) {
    throw new Error(
      `Unable to extract a YouTube video id from "${youtubeUrl}"`
    );
  }
  return videoId;
};

export const getYouTubeEmbedUrl = (youtubeUrl: string): string =>
  // rel=0 keeps the end screen on Libertify's own channel.
  // youtube-nocookie sets fewer tracking cookies once the user clicks play.
  `https://www.youtube-nocookie.com/embed/${getYouTubeVideoId(youtubeUrl)}?rel=0&autoplay=1`;
